import React from 'react';
import { useState, useEffect } from 'react';
import './style.scss'
import { useNavigate } from 'react-router-dom';
import { Input, Select, Space, Checkbox, Spin } from 'antd';
import { addWebsiteCollect } from '../../../api'
import { LoadingOutlined } from '@ant-design/icons';
const options = [
    {
        value: '852',
        label: '852',
    },
    {
        value: '853',
        label: '853',
    },
];
const styles = {
    background: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        background: '#fff',
        padding: '20px 20px',
        borderRadius: '8px',
        textAlign: 'center',
    }
};
const SinobusHK = () => {
    const [phone, setPhone] = useState(null);
    const [areaCode, setAreaCode] = useState(null);
    const [promptText, setPromptText] = useState('');
    const [checked, setChecked] = useState(true);
    const [grade, setGrade] = useState(null);
    const [classLanguage, setClassLanguage] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [gradeText, setGradeText] = useState('');
    const [languageText, setLanguageText] = useState('');

    const nav = useNavigate();
    const onFinish = () => {
        // 1.先判断 是否有区号
        // 2.判断是否有手机号
        if (grade) {
            setGradeText("");
        } else {
            setGradeText('請選擇上課年級')
        }
        if (classLanguage) {
            setLanguageText("");
        } else {
            setLanguageText('請選擇上課語言')
        }
        if (areaCode) {
            if (/^(?!(\d)\1{7})\d{8}$/.test(phone)) {
                setPromptText('');
                if (grade && classLanguage) {
                    addWebsiteCollect({
                        "phone": areaCode + '-' + phone,
                        "origin": "SinobusHK",
                        'grade': grade,
                        'classLanguage': classLanguage
                    }).then((res) => {
                        console.log(res)
                        // 跳转到Thankyou页面
                        window.location.href = '/thankyou';

                    }).catch(function (error) {
                        console.log(error);

                    });
                }

            } else {
                setPromptText('請輸入正確的手機號碼')
            }
        } else {
            setPromptText('請選擇WhatsApp國家/地區')
        }
    };
    let isTrue = false;
    useEffect(() => {
        if (isTrue === false) {
            isTrue = true;
            const scriptDiv1 = document.createElement('script');
            scriptDiv1.innerHTML = ` {(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-MH29QND');}`;
            document.head.appendChild(scriptDiv1);

            const noscript = document.createElement('noscript');
            noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MH29QND"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
            document.body.appendChild(noscript);
        }
    }, []);
    const onChange = (e) => {

        const value = e.target.value;
        if (/^[0-9]*$/.test(value)) {
            console.log('通过正则表达式验证的电话号码：', /^[0-9]*$/.test(value));
            if (/^\d{0,8}$/.test(value)) {
                setPhone(value);  // 更新电话号码
            }
        }
    };
    // 用于关闭弹框
    const handleClose = (e) => {
        e.stopPropagation(); // 阻止事件冒泡
    };
    // 点击背景区域时关闭弹框
    const handleBackgroundClick = () => {
        setIsModalVisible(false)
    };
    const openModal = () => setIsModalVisible(true);
    const formCom = () => {
        return (
            <div className='sinobusHK-form-content'>
                <div className='claim'>
                    <img className='icon-img' src="../assets/sinobusHk/icon_left.png" alt="" />
                    <img className='text-img' src="../assets/sinobusHk/text.png" alt="" />
                    <img className='icon-img' src="../assets/sinobusHk/icon_right.png" alt="" />
                </div>
                <div className='select-div'>
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        size="large"
                        placeholder="請選擇上課年級"
                        onChange={(value) => { setGrade(value) }}
                        options={[
                            { value: '小一', label: '小一' },
                            { value: '小二', label: '小二' },
                            { value: '小三', label: '小三' },
                            { value: '小四', label: '小四' },
                            { value: '小五', label: '小五' },
                            { value: '小六', label: '小六' },
                        ]}
                    />
                    <div className='prompt'>{gradeText}</div>
                    <Select
                        showSearch
                        size="large"
                        style={{ width: '100%' }}
                        placeholder="請選擇上課語言"
                        onChange={(value) => { setClassLanguage(value) }}
                        options={[
                            { value: '粵語', label: '粵語' },
                            { value: '普通話', label: '普通話' },
                        ]}
                    />
                    <div className='prompt'>{languageText}</div>
                </div>
                <Space.Compact>
                    <Select size='large' placeholder="請選擇" options={options} onChange={(value) => { setAreaCode(value) }} />
                    <Input size="large" style={{ fontSize: "16px" }} placeholder="輸入WhatsApp號碼領取優惠" value={phone} maxLength={8} onChange={(e) => { onChange(e) }} />
                </Space.Compact>
                <div className='prompt'>{promptText}</div>

                <div className='sub-bnt' onClick={() => { onFinish() }}>立即領取</div>
                <Checkbox checked={checked} onChange={(e) => { setChecked(e.target.checked); }}></Checkbox><span className='policy'> 我已閱讀並同意 <span onClick={() => { nav('/policy') }}>《用戶協議》</span> 和 <span onClick={() => { nav('/privacy') }}>《隱私協議》</span></span>
                <p className='policy'>24小時內會有專人聯繫，請留意WhatsApp信息</p>
            </div>
        )
    }
    return (
        <div className="SinobusHK">
            <div className='form-div' id='reference-div' >
                {formCom()}
            </div>
            <div className='foot-div'>
                <img src="../assets/sinobusHk/banner_footer.png" alt="" />
            </div>
            <div id="footer-div" >
                <button onClick={openModal} className='open-btn'>立即領取</button>
            </div>
            {
                isModalVisible && (
                    <div
                        className="modal-background"
                        onClick={handleBackgroundClick}
                        style={styles.background}
                    >
                        <div
                            className="modal-content"
                            onClick={handleClose}
                            style={styles.modal}
                        >
                            {formCom()}
                        </div>
                    </div>
                )
            }

        </div >
    )
}
export default SinobusHK;